import { useParams, Link } from "react-router-dom";
import { Fotter } from "../../components";

const projects = [
  {
    title: "TRACE Bot",
    slug: "trace-bot",
    description:
      "TRACE Bot — zavodlar va yirik korxonalar uchun davomatni boshqarishni yaxshilashga qaratilgan loyiha. U turniketlardagi harakatlarni kuzatadi va xodimlarning ish joyidagi mavjudligini nazorat qiladi.",
    image: "/img/tracebotimg.jpg",
  },
  {
    title: "Budget Manager Bot",
    slug: "budget-manager-bot",
    description:
      "Budget Manager Bot — bizneslar uchun moliyaviy jarayonlarni avtomatlashtirishga yordam beradigan loyiha. U buxgalteriya ishlarini soddalashtiradi va xatolarni kamaytiradi.",
    image: "/img/budgetbot.jpg",
  },
];

const ProjectDetail = () => {
  const { slug } = useParams();
  const project = projects.find((p) => p.slug === slug);

  if (!project) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 text-gray-800">
        <h2 className="text-2xl font-semibold">Loyiha topilmadi 😕</h2>
      </div>
    );
  }

  return (
  <>
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-36">
      <div className="max-w-3xl w-full bg-white shadow-xl rounded-2xl overflow-hidden">
        <img
          src={project.image}
          alt={project.title}
          className="w-full h-64 object-cover"
        />
        <div className="p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            {project.title}
          </h1>
          <p className="text-gray-600 text-lg mb-6">{project.description}</p>
          <Link
            to="/loyihalarmiz"
            className="inline-block bg-indigo-600 text-white px-5 py-2 rounded-lg hover:bg-indigo-700 transition"
          >
            ← Orqaga qaytish
          </Link>
        </div>
      </div>
    </div>
    <Fotter />
  </>
  );
};

export default ProjectDetail;
